import Authenticate from "./authenticate"

export default function AuthenticationScreen() {
  return (
    <div className="w-screen h-screen flex flex-col justify-center px-4">
      <Authenticate />
    </div>
  )
}
